import {
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const authRefreshInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    if (
        !req.url.includes('/api/users/refresh') &&
        authService.accessToken &&
        AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        return authService.refreshAccessToken().pipe(
            switchMap((_) => {
                return next(req);
            })
        );
    }

    return next(req);
};
